/**
 * 「先问一句」（删掉、不教了）：就地展开一块，不弹全屏遮罩。
 * - 有名字（aria-label，评审第二轮中 3）和描述（问话那句）；打开时焦点落在安全的那个键（留着），页面会滚到它；
 * - Esc 等于「留着」；关掉以后焦点回到打开它的那个键（评审第一轮高 6）；
 * - 两个键请求中只标 aria-busy／aria-disabled、不真禁用，焦点不丢（评审第二轮高 1）。
 */
import { useEffect, useId, useRef, type RefObject } from "react";
import { KEEP } from "./teachModel";
import { TeachButton } from "./TeachButton";

export function TeachAsk({ label, text, yes, busy, onYes, onNo, returnTo }: { label: string; text: string; yes: string; busy: boolean; onYes: () => void; onNo: () => void; returnTo: RefObject<HTMLElement | null> }) {
  const id = useId();
  const keep = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    keep.current?.focus();
  }, []);
  const close = () => {
    onNo();
    window.setTimeout(() => returnTo.current?.focus(), 0);
  };
  return (
    <div
      className="ps-teach-ask"
      role="alertdialog"
      aria-modal="false"
      aria-label={label}
      aria-describedby={id}
      onKeyDown={(event) => {
        if (event.key === "Escape" && !busy) {
          event.stopPropagation();
          close();
        }
      }}
    >
      <p id={id} className="ps-teach-ask__text">{text}</p>
      <div className="ps-teach-actions">
        <TeachButton buttonRef={keep} variant="secondary" block unavailable={busy} onClick={close}>{KEEP}</TeachButton>
        <TeachButton variant="danger" block busy={busy} onClick={onYes}>{yes}</TeachButton>
      </div>
    </div>
  );
}
